

import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import {
    headers, fetchDRCListUrl,
    getDRCDetailsUrl,
    insertUpdateDRCUrl, GET_DRC_LIST,
    GET_DRC_DETAILS,
    INSERT_UPDATE_DRC, delateDRCUrl,
    DELETE_DRC
} from "../../../utils/constants";

export const fetchDRCList_action = (ProgramTitle, FromDate, ToDate, Area, ResponsiblePerson) => async (dispatch) => {
    try {
        const params = {
            // UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            // ExhRegistrationID: ExhRegistrationID,
            // DD_Number: DD_Number,
            // DD_Date: DD_Date,
            // HallID: HallID,
            ProgramTitle: ProgramTitle,
            FromDate: FromDate,
            ToDate: ToDate,
            HallId: Area,
            ResponsiblePerson: ResponsiblePerson,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(fetchDRCListUrl, params, headers)

        dispatch({
            type: GET_DRC_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDRCDetails_action = (DailyRoutineChecklistHdrID) => async (dispatch) => {
    try {
        const params = {
            // UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DailyRoutineChecklistHdrID: DailyRoutineChecklistHdrID,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getDRCDetailsUrl, params, headers)

        dispatch({
            type: GET_DRC_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateDRC_action = (
    DailyRoutineChecklistHdrID, ProgramTitle, FromDate, ToDate, PreAlertTime, ScheduleTime, HallID, IsHallManager, scheduleTimeList, hallList, checkList) => async (dispatch) => {
        try {
            const mapData = {
                UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
                ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
                DailyRoutineChecklistHdrID: DailyRoutineChecklistHdrID,
                ProgramTitle: ProgramTitle,
                FromDate: FromDate,
                ToDate: ToDate,
                PreAlertTime: PreAlertTime,
                ScheduleTime: ScheduleTime,
                HallID: HallID,
                IsHallManager: IsHallManager,
                scheduleTimeList: scheduleTimeList,
                hallList: hallList,
                checkList: checkList
            }
            console.log("addVisaApplication_action------->", mapData)
            const res = await axiosPost(insertUpdateDRCUrl, mapData, headers)

            dispatch({
                type: INSERT_UPDATE_DRC,
                payload: res
            })
            return Promise.resolve(res)
        } catch (error) {
            return Promise.reject(error)
        }
    }

export const delateDRC_action = (DailyRoutineChecklistHdrID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DailyRoutineChecklistHdrID: DailyRoutineChecklistHdrID,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(delateDRCUrl, params, headers)

        dispatch({
            type: DELETE_DRC,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}